import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=ccf041fa"
import script from "./provider.vue?vue&type=script&lang=js"
export * from "./provider.vue?vue&type=script&lang=js"
import style0 from "./provider.vue?vue&type=style&index=0&id=ccf041fa&prod&scope=true&lang=css"
import style1 from "./provider.vue?vue&type=style&index=1&id=ccf041fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports